// Dietz-Schell Winder
import React from "react";
import { Input, Row } from "reactstrap";
import { ColValue, ErrorDiv } from "../ProductionModule/index";
import { ColPrompt, CommonRows, InputRangeRow, RunTimeRow } from "./index";
import { useMachineSetupContextUpdater } from "./useMachineSetupContextUpdater";
import { useMachineSetupContextState } from "./useMachineSetupContextState";

export default function MachineDS21() {
   const { handleInputRangeChange } = useMachineSetupContextUpdater();
   const { machineSetup, errorDivDefinitions } = useMachineSetupContextState();
   const defaultOnChangeVal = { target: { value: "" } };
   return (
      <>
         <Row className="mb-2">
            <ColPrompt title={"Clock Setting"} bold={true} description={"m"} />
            <ColValue size={4}>
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.clockSetting || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 1, 99999, "clockSetting")
                        : handleInputRangeChange(defaultOnChangeVal, 1, 99999, "clockSetting")
                  }
               />
               {errorDivDefinitions.clockSetting && (
                  <ErrorDiv>1-99,999 only</ErrorDiv>
               )}
            </ColValue>
         </Row>

         <Row className="mb-2">
            <ColPrompt title={"Speed Setting"} bold={true} />
            <ColValue size={4}>
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.speedSetting || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 1, 999, "speedSetting")
                        : handleInputRangeChange(defaultOnChangeVal, 1, 999, "speedSetting")
                  }
               />
               {errorDivDefinitions.speedSetting && (
                  <ErrorDiv>1-999 only</ErrorDiv>
               )}
            </ColValue>
         </Row>

         <RunTimeRow />

         <Row className="mb-2">
            <ColPrompt
               title={"Beginning Back Pressure"}
               bold={true}
               description={"kg"}
            />
            <ColValue size={2}>
               Min:
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.begBackPressureMin || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 0, 10, "begBackPressureMin", "float")
                        : handleInputRangeChange(defaultOnChangeVal, 0, 10, "begBackPressureMin")
                  }
               />
               {errorDivDefinitions.begBackPressureMin && (
                  <ErrorDiv>0.00-10.00 only</ErrorDiv>
               )}
            </ColValue>
            <ColValue size={2}>
               Max:
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.begBackPressureMax || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 0, 10, "begBackPressureMax", "float")
                        : handleInputRangeChange(defaultOnChangeVal, 0, 10, "begBackPressureMax")
                  }
               />
               {errorDivDefinitions.begBackPressureMax && (
                  <ErrorDiv>0.00-10.00 only</ErrorDiv>
               )}
            </ColValue>
         </Row>

         <Row className="mb-2">
            <ColPrompt
               title={"Ending Back Pressure"}
               bold={true}
               description={"kg"}
            />
            <ColValue size={2}>
               Min:
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.endBackPressureMin || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 0, 10, "endBackPressureMin", "float")
                        : handleInputRangeChange(defaultOnChangeVal, 0, 10, "endBackPressureMin")
                  }
               />
               {errorDivDefinitions.endBackPressureMin && (
                  <ErrorDiv>0.00-10.00 only</ErrorDiv>
               )}
            </ColValue>
            <ColValue size={2}>
               Max:
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.endBackPressureMax || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 0, 10, "endBackPressureMax", "float")
                        : handleInputRangeChange(defaultOnChangeVal, 0, 10, "endBackPressureMax")
                  }
               />
               {errorDivDefinitions.endBackPressureMax && (
                  <ErrorDiv>0.00-10.00 only</ErrorDiv>
               )}
            </ColValue>
         </Row>

         <Row className="mb-2">
            <ColPrompt title={"Beginning Tension"} bold={true} description={"g"} />
            <ColValue size={2}>
               Min:
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.begTensionMin || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 0, 600, "begTensionMin")
                        : handleInputRangeChange(defaultOnChangeVal, 0, 600, "begTensionMin")
                  }
               />
               {errorDivDefinitions.begTensionMin && (
                  <ErrorDiv>0-600 only</ErrorDiv>
               )}
            </ColValue>
            <ColValue size={2}>
               Max:
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.begTensionMax || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 0, 600, "begTensionMax")
                        : handleInputRangeChange(defaultOnChangeVal, 0, 600, "begTensionMax")
                  }
               />
               {errorDivDefinitions.begTensionMax && (
                  <ErrorDiv>0-600</ErrorDiv>
               )}
            </ColValue>
         </Row>

         <Row className="mb-2">
            <ColPrompt title={"Number Fields"} bold={true} />
            <ColValue size={4}>
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.numFields || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 4, 60, "numFields")
                        : handleInputRangeChange(defaultOnChangeVal, 4, 60, "numFields")
                  }
               />
               {errorDivDefinitions.numFields && (
                  <ErrorDiv>4-60 only</ErrorDiv>
               )}
            </ColValue>
         </Row>

         <Row className="mb-2">
            <ColPrompt title={"Gear A"} bold={true} />
            <ColValue size={4}>
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.gearA || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 12, 50, "gearA")
                        : handleInputRangeChange(defaultOnChangeVal, 12, 50, "gearA")
                  }
               />
               {errorDivDefinitions.gearA && (
                  <ErrorDiv>12-50 only</ErrorDiv>
               )}
            </ColValue>
         </Row>

         <Row className="mb-2">
            <ColPrompt title={"Gear B"} bold={true} />
            <ColValue size={4}>
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.gearB || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 12, 50, "gearB")
                        : handleInputRangeChange(defaultOnChangeVal, 12, 50, "gearB")
                  }
               />
               {errorDivDefinitions.gearB && (
                  <ErrorDiv>12-50 only</ErrorDiv>
               )}
            </ColValue>
         </Row>

         
         {/* These fields are not in use right now */}
         {/*
         <Row className="mb-2">
            <ColPrompt title={"Tension Release Speed Arm"} bold={true} />
            <ColValue size={4}>
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.tensionSpeedArm || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 1, 5, "tensionSpeedArm")
                        : handleInputRangeChange(defaultOnChangeVal, 1, 5, "tensionSpeedArm")
                  }
               />
               {errorDivDefinitions.tensionSpeedArm && (
                  <ErrorDiv>1-5 only</ErrorDiv>
               )}
            </ColValue>
         </Row>

         <Row className="mb-2">
            <ColPrompt title={"Spring Pos Top"} bold={true} />
            <ColValue size={4}>
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.springPosTop || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 1, 5, "springPosTop")
                        : handleInputRangeChange(defaultOnChangeVal, 1, 5, "springPosTop")
                  }
               />
               {errorDivDefinitions.springPosTop && (
                  <ErrorDiv>1-5 only</ErrorDiv>
               )}
            </ColValue>
         </Row>

         <Row className="mb-2">
            <ColPrompt title={"Spring Pos Bottom"} bold={true} />
            <ColValue size={4}>
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.springPosBottom || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 1, 3, "springPosBottom")
                        : handleInputRangeChange(defaultOnChangeVal, 1, 3, "springPosBottom")
                  }
               />
               {errorDivDefinitions.springPosBottom && (
                  <ErrorDiv>1-3 only</ErrorDiv>
               )}
            </ColValue>
         </Row>

         <Row className="mb-2">
            <ColPrompt title={"Spring Plate"} bold={true} description={"m"} />
            <ColValue size={4}>
               <Input
                  type="text"
                  style={{ borderRadius: "10px", fontSize: "14px" }}
                  value={machineSetup.extendedPropertyJson.springPlate || ""}
                  onChange={(e) =>
                     e.target.value
                        ? handleInputRangeChange(e, 1, 3, "springPlate")
                        : handleInputRangeChange(defaultOnChangeVal, 1, 3, "springPlate")
                  }
               />
               {errorDivDefinitions.springPlate && (
                  <ErrorDiv>1-3 only</ErrorDiv>
               )}
            </ColValue>
         </Row>

          */}

         <InputRangeRow
            titleProp={"Applicator Roll RPM"}
            descriptionProp={""}
            sizeProp={4}
            colSizeProp={3}
            typeProp={"text"}
            minProp={0.0}
            maxProp={40.0}
            propertyNameProp={"applicatorRollRPM"}
            errorDialogueProp={"0.0-40.0 only"}
            floatProp={true}
         />

         <CommonRows />
      </>
   );
}
